var map = {
	"./bg_panflet_daughter.png": "Mgfa",
	"./bg_panflet_son.png": "YTGU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5tgP";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent ^\.\/bg_panflet_.*\.png$
// module id = 5tgP
// module chunks = 0